class PrefilledField {
  constructor(fieldName, value) {
    this.fieldName = fieldName;
    this.value = value;
  }
}

export { PrefilledField };
